// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Statement extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  customerNames = '';
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  code!: string;
  created!: Date;
  createdBy?: string;
  customerIds?: string;
  deleted?: Date;
  deletedBy?: string;
  filename?: string;
  name?: string;
}

